module.exports = __webpack_public_path__ + "static/media/smartCloud.914ba483.png";